import PropTypes from 'prop-types';
import React, { FC } from 'react';
import styled from 'styled-components';
import { theme as t } from '../AssetUrlTheme';


const Root = styled.div`
  display: flex;
  align-items: center;

  padding: ${t.container.padding};
  background-color: ${t.container.backgroundColor};
  border: 1px solid ${t.container.borderColor};
  border-radius: ${t.container.borderRadius};
`;

const AssetUrlContainer: FC = ({ children }) => <Root>{children}</Root>;

AssetUrlContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AssetUrlContainer;
